module.exports = __webpack_public_path__ + "img/delete.fd392841.svg";